/**
 * @fileoverview Input/output schemas for character-details-ideation-v2.
 *
 * This agent generates three high-level summary concepts for a character.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

/**
 * Full input for the agent flow.
 */
export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.storyContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.initialChapterContent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.characterName.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.existingDetails.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.userMessage.schema.shape,
});

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

export const OutputSchema = z.object({
  ideas: z.array(z.object({
    title: z.string().describe("A short, evocative title for this character concept."),
    summary: z.string().describe("A concise one-paragraph summary of the character's age, physical appearance, personality, core values and cultural/ethnic background."),
  })).length(3).describe("An array of exactly three distinct character detail concepts."),
});

export type Output = z.infer<typeof OutputSchema>;
